<template>
    <div style="margin-bottom: 10vh;">
        <ul style="list-style:none;margin:10px 0;">
            <li>
                <div>
                    <h3>Languages</h3>
                    <dl>
                        <dt>JAVA</dt>
                        <dd>Intermediate</dd>
                        <dt>Ruby</dt>
                        <dd>Intermediate</dd>
                        <dt>C</dt>
                        <dd>Intermediate</dd>
                        <dt>Python</dt>
                        <dd>Beginner</dd>
                        <dt>Go</dt>
                        <dd>Beginner</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>Web Technologies/Frameworks</h3>
                    <dl>
                        <dt>Node.js Express</dt>
                        <dd>Intermediate</dd>
                        <dt>Nestjs</dt>
                        <dd>Intermediate</dd>
                        <dt>RestFul Web Services</dt>
                        <dd>Intermediate</dd>
                        <dt>Ruby on Rails</dt>
                        <dd>Intermediate</dd>
                        <dt>GraphQL</dt>
                        <dd>Beginner</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>Databases</h3>
                    <dl>
                        <dt>MongoDb</dt>
                        <dd>Intermediate</dd>
                        <dt>MySQL</dt>
                        <dd>Intermediate</dd>
                        <dt>Postgresql</dt>
                        <dd>Intermediate</dd>
                        <dt>Firebase Realtime Database</dt>
                        <dd>Expert</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>Cloud Services</h3>
                    <dl>
                        <dt>AWS</dt>
                        <dd>EC2 Instance,Lamda,S3,VPC</dd>
                        <dd>Intermediate</dd>
                        <dt>Google Cloud</dt>
                        <dd>GCE,Storage</dd>
                        <dd>Intermediate</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>Deployment</h3>
                    <dl>
                        <dt>Nginx</dt>
                        <dd>Intermediate</dd>
                        <dt>Docker</dt>
                        <dd>Intermediate</dd>
                        <dt>Kuberneetes</dt>
                        <dd>Intermediate</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>Frontend</h3>
                    <dl>
                        <dt>HTML</dt>
                        <dd>Intermediate</dd>
                        <dt>CSS</dt>
                        <dd>Beginner</dd>
                        <dt>JavaScript</dt>
                        <dd>Intermediate</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>Android</h3>
                    <dl>
                        <dt>XML</dt>
                        <dd>ntermediate</dd>
                        <dt>Firebase</dt>
                        <dd>Intermediate</dd>
                        <dt>Firebase Cloud Messaging</dt>
                        <dd>Expert</dd>
                    </dl>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Skills"
};
</script>



// WEBPACK FOOTER //
// src/components/skillsComponent.vue